import { render, staticRenderFns } from "./individualFooter.vue?vue&type=template&id=bed61cd0&"
import script from "./individualFooter.vue?vue&type=script&lang=js&"
export * from "./individualFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports